module.exports = __webpack_public_path__ + "static/img/KR.b714748.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/KR.svg
// module id = I/nG
// module chunks = 66